import classNames from 'classnames';
import isFunction from 'lodash/isFunction';
import { InputText } from 'primereact/inputtext';
import React, { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { SegmentEventTypes } from '../../data/tracking';
import Analytics from '../../utils/Analytics';
import LabelWrapper from '../LabelWrapper.component';
import WrappedTooltip from '../overlay/WrappedTooltip.component';

export const WrappedInputText = props => {
	const {
		className,
		isInputInvalid,
		dataqa = 'ui',
		showPasswordTabIndex,
		showPasswordTooltip,
		hidePasswordTooltip,
		onFocus,
		onBlur,
		...config
	} = props;
	const [isShow, setIsShow] = useState(false);
	const [uniqueId] = useState(`eye-icon${uuidv4()}`);

	const inputTextClassName = classNames(className, {
		'invalid-component': isInputInvalid,
	});

	const { type, tabIndex } = config;

	if (type === 'password' && tabIndex && showPasswordTabIndex === null) {
		console.warn(
			'showPasswordTabIndex is required if tabIndex is supplied to password type'
		);
	}

	const focusHandler = e => {
		Analytics.trackSegmentEvent({
			trackingData: {
				field_type: 'inputtext',
				field_name_dataqa: `${dataqa}-input-text`,
			},
			eventType: SegmentEventTypes.UserInputStarted,
		});

		if (isFunction(onFocus)) {
			onFocus(e);
		}
	};

	const blurHandler = e => {
		Analytics.trackSegmentInputEvent({
			trackingData: {
				field_type: 'inputtext',
				field_name_dataqa: `${dataqa}-input-text`,
			},
			eventType: SegmentEventTypes.UserInputCompleted,
			fieldValue: e.target?.value,
		});

		if (isFunction(onBlur)) {
			onBlur(e);
		}
	};

	return (
		<div className="common-ui-input-text">
			{type === 'password' ? (
				<span className="common-ui-input-icon-right">
					<InputText
						className={inputTextClassName}
						data-qa={`${dataqa}-input-text`}
						dataqa={`${dataqa}-input-text`}
						onFocus={focusHandler}
						onBlur={blurHandler}
						{...config}
						type={isShow ? 'text' : 'password'}
					/>
					<span
						className={`${isShow ? 'hide-password' : 'show-password'} ${uniqueId}`}
						onClick={() => {
							setIsShow(!isShow);
						}}
						role="button"
						tabIndex={showPasswordTabIndex}
						aria-label="Toggle"
						{...{ dataqa: `${dataqa}-show-password-button` }}
					/>
					<WrappedTooltip
						tooltip={
							isShow
								? hidePasswordTooltip || 'Hide password'
								: showPasswordTooltip || 'Show password'
						}
						target={uniqueId}
					/>
				</span>
			) : (
				<InputText
					className={inputTextClassName}
					data-qa={`${dataqa}-input-text`}
					dataqa={`${dataqa}-input-text`}
					onFocus={focusHandler}
					onBlur={blurHandler}
					{...config}
				/>
			)}
		</div>
	);
};

export const WrappedInputTextWithLabel = LabelWrapper(WrappedInputText);
